export type UserRole = 'user' | 'chef' | 'admin';

export function userRoleFromJson(value: string | null | undefined): UserRole {
  switch (value) {
    case 'chef':
      return 'chef';
    case 'admin':
      return 'admin';
    default:
      return 'user';
  }
}

export function userRoleLabel(role: UserRole): string {
  switch (role) {
    case 'admin':
      return 'Administrator';
    case 'chef':
      return 'Platformski kuvar';
    default:
      return 'Korisnik';
  }
}
